import {Show} from 'platform/foundation';

import {useTenant} from '@dms/shared';

import {VehicleForm as VFKit} from '../VehicleForm';

export function EmissionsGroup() {
  const {isTenantCountryRestricted} = useTenant();
  const isWltpCo2Visible = isTenantCountryRestricted(['BEL', 'DEU']);

  return (
    <>
      <VFKit.ShowWhen
        name="hybridType"
        condition={(hybridType) => hybridType?.[0] !== 'HYBRIDTYPE_PHEV'}
      >
        <VFKit.EmissionClassSelect />
        <VFKit.CarbonDioxideEmissionField />
        <Show when={isWltpCo2Visible}>
          <VFKit.CarbonDioxideEmissionClassSelect />
        </Show>
      </VFKit.ShowWhen>
      <VFKit.ShowWhen
        watchFields={['fuelType', 'hybridType']}
        condition={(values) =>
          values.fuelType?.[0] === 'FUELTYPE_HYBRID' && values.hybridType?.[0] === 'HYBRIDTYPE_PHEV'
        }
      >
        <Show when={isWltpCo2Visible}>
          <VFKit.CarbonDioxideEmissionWeightedCombinedField />
          <VFKit.CarbonDioxideEmissionClassWeightedCombinedSelect />
          <VFKit.CarbonDioxideEmissionDischargedField />
          <VFKit.CarbonDioxideEmissionClassDischargedSelect />
        </Show>
        <VFKit.EmissionClassSelect />
      </VFKit.ShowWhen>
    </>
  );
}
